// extracted by mini-css-extract-plugin
export default {"root":"activity_type_badge___root___ac000846","icon":"activity_type_badge___icon___c000ed5d","text":"activity_type_badge___text___dfb8f60c"};